import  { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import service from "../stage/stageService";
import BattleReportMobile from "./BattleReportMobile";
import isDesktop from "../isDesktop";
import { hasStoredTabAccess } from '../utils/access';

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import { useLocalStorage } from "@uidotdev/usehooks";
import { toast, ToastContainer } from "react-toastify";
const BattleReport = ({users}) => {
  const isDesktopDevice = isDesktop();
  const [battles, setBattles] = useState([]);
  const [skills, setSkills] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [token,setToken] = useLocalStorage('token',null);
  const [filter, setFilter] = useState(null);
  const [stages, setStages] = useState([]);
  const [selectedStage, setSelectedStage] = useState("");
  const [selectedBattle, setSelectedBattle] = useState("");
  const isAuthorized = hasStoredTabAccess('Report');

  const handleInputChange = (e, value) => {
    setFilter(value?.username);
  };


  const handleExportClick = async () => {
    if(selectedSkill.length === 0) {
      console.log("No skill selected")
      toast.error("No skill selected");
      return
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/report/export-battle`,
        {
          name: filter,
          battle_id: selectedBattle,
          skill_id: selectedSkill,
          stage_id: selectedStage
        },
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "BattleAttempts.xlsx");
      document.body.appendChild(link);
      link.click();
      console.log("File exported successfully");
    } catch (error) {
      console.error("Error exporting file:", error);
      if (error.response.status==400) {
        toast.error("No data found")
      }
    }
  };

  const fetchSkills = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/skills/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setSkills(response.data.data);
      } else {
        console.error("Error fetching skills: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching skills: ", error);
    }
  };

  const handleSkillChange = (event) => {
    const selectedSkillId = event.target.value;
    setSelectedSkill(selectedSkillId);
    fetchStages(selectedSkillId);
  };

  const fetchBattles = async (stageId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/battle/all/${stageId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setBattles(response.data.data);
      } else {
        console.error("Error fetching battles:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching battles:", error);
    }
  };

  const fetchStages = async (selectedSkill) => {
    try {
      const fetchedStages = await service.getStages(token, selectedSkill);
      setStages(fetchedStages);
    } catch (error) {
      console.error("Error fetching stages: ", error);
    }
  };

  const handleReset = () => {
    setFilter("");
    setSelectedSkill("");
    setSelectedBattle("");
    setSelectedStage("");
  };

  useEffect(() => {
    if(isDesktopDevice && isAuthorized) {
      fetchSkills();
      // fetchReports();
    }
  }, [selectedSkill, filter, isAuthorized, isDesktopDevice]);

  if(!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2>You are unauthorized to access this page</h2>
      </div>
    )
  }

  return (
    <>
    {
      isDesktopDevice ? (
        <div className="container-fluid mt-3 p-0">
          <ToastContainer />
      <div className="align-center-all full-height">
        <Card sx={{boxShadow: 'none'}}>
          <CardContent>
            <div className="filters">
            <div className="sub-title">Battle Report</div>
              <div
                style=
                {{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <div className="fieldContainer">
                  <div className="leftFields">
                    <FormControl
                      fullWidth
                      className="mb-3 customTextfield"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'transparent',
                          },
                          '&:hover fieldset': {
                            borderColor: 'transparent',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'transparent',
                            boxShadow: 'none',
                          },
                        },
                        width: '32.051vw'
                      }}
                    >
                    <InputLabel id="skill-labels">Skill</InputLabel>
                    <Select
                      labelId="skill-label"
                      id="skill-select"
                      label="Skill"
                      value={selectedSkill}
                      onChange={handleSkillChange}
                    >
                      <MenuItem value="">None</MenuItem>
                      {skills.map((skill) => (
                        <MenuItem key={skill.skill_id} value={skill.skill_id}>
                          {skill.skill_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl
                      fullWidth
                      className="mb-3 customTextfield"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'transparent',
                          },
                          '&:hover fieldset': {
                            borderColor: 'transparent',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'transparent',
                            boxShadow: 'none',
                          },
                        },
                        width: '32.051vw'
                      }}
                    >
                    <InputLabel id="stages-label">Stages</InputLabel>
                    <Select
                      labelId="stages-label"
                      id="stages-select"
                      label="Stage"
                      value={selectedStage}
                      onChange={(e) => {
                        const selectedStageId = e.target.value;
                        setSelectedStage(selectedStageId);
                        fetchBattles(selectedSkill, selectedStageId);
                      }}
                    >
                      <MenuItem value="">None</MenuItem>
                      {Array.isArray(stages.stages) &&
                        stages.stages.map((stage) => (
                          <MenuItem key={stage.stage_id} value={stage.stage_id}>
                            {stage.stage_name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  </div>
                  <div className="rightFields">
                  <FormControl
                      fullWidth
                      className="mb-3 customTextfield"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'transparent',
                          },
                          '&:hover fieldset': {
                            borderColor: 'transparent',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'transparent',
                            boxShadow: 'none',
                          },
                        },
                        width: '32.051vw'
                      }}
                    >
                    <InputLabel id="battle-label">Battle</InputLabel>
                    <Select
                      labelId="battle-label"
                      id="battle-select"
                      label="Battle"
                      onChange={(e) => {
                        const selectedBattleId = e.target.value;
                        setSelectedBattle(selectedBattleId);
                      }}
                      value={selectedBattle}
                    >
                      <MenuItem value="">None</MenuItem>
                      {battles.map((battle) => (
                        <MenuItem
                          key={battle.battle_id}
                          value={battle.battle_id}
                        >
                          {battle.battle_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Autocomplete
                    id="userId"
                    options={users}
                    getOptionLabel={(option) => option.username}
                    value={filter ? users.find((user) => user.username === filter) : null}
                    onChange={handleInputChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        placeholder="Username"
                        className="mb-3 customTextfield"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: 'transparent',
                            },
                            '&:hover fieldset': {
                              borderColor: 'transparent',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: 'transparent',
                              boxShadow: 'none',
                            },
                          },
                          width: '32.051vw'
                        }}
                      />
                    )}
                  />
                  </div>
                </div>
                <div style={{display: 'flex', gap: '1.2vw', alignItems: 'center', justifyContent: 'center' }}>
                      <Button
                        variant="outlined"
                        className="outlined-button"
                        onClick={handleReset}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleExportClick}
                        className="filled-button"
                      >
                        Export
                      </Button>
                    </div>
                    </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
      ) : (
        <BattleReportMobile />
      )
    }
    </>
  );
};
export default BattleReport;
